import type { components } from '@trackercop/contracts';
import { formatDateTime, formatUsd } from '@/lib/format';

type CostReport = components['schemas']['CostReport'];

interface CostHeadlineProps {
  report: CostReport;
}

export function CostHeadline({ report }: CostHeadlineProps) {
  return (
    <div
      className="grid gap-4 rounded-lg border bg-background p-6 sm:grid-cols-3"
      data-testid="cost-headline"
    >
      <div>
        <div className="text-xs uppercase tracking-wide text-muted-foreground">
          Projected total ({report.month})
        </div>
        <div className="mt-1 text-3xl font-semibold tabular-nums">
          {formatUsd(report.projectedTotalUsd)}
        </div>
        <div
          className="mt-1 text-xs text-muted-foreground"
          title="Projection = MTD subtotal × (days in month ÷ days elapsed). Linear extrapolation only — not the Cloudflare invoice."
        >
          Linear projection from MTD run-rate
        </div>
      </div>
      <div>
        <div className="text-xs uppercase tracking-wide text-muted-foreground">
          Month-to-date
        </div>
        <div className="mt-1 text-3xl font-semibold tabular-nums">
          {formatUsd(report.subtotalUsd)}
        </div>
        <div className="mt-1 text-xs text-muted-foreground">
          Day {report.daysElapsed} of {report.daysInMonth}
        </div>
      </div>
      <div>
        <div className="text-xs uppercase tracking-wide text-muted-foreground">
          Catalog
        </div>
        <div className="mt-1 font-mono text-base">
          {report.catalogVersion}
        </div>
        <div className="mt-1 text-xs text-muted-foreground">
          Generated {formatDateTime(report.generatedAt)}
        </div>
      </div>
    </div>
  );
}
